<article>
  @defer (when issue()) {
    <header>
      <app-toolbar>
        <div class="right">
          @if (issue().status === 'created' || issue().status === 'in progress' || issue().status === 'open') {
            <app-button label="Complete" icon="mdi mdi-check" (click)="wantsToCompleteClick()" [isCTA]="true" />
          } @else {
            Issue is closed.
          }
        </div>
      </app-toolbar>
    </header>

    <section class="content-container edit mt-1">
      <div class="flex">
        <div class="flex-1">
          <h4>Summary</h4>
          <input class="fourd" type="text" [(ngModel)]="editForm().title" />
        </div>
        @if (issue().status !== 'created' && issue().status === 'in progress') {
          <div class="">
            <h4>Resolved</h4>
            <input class="fourd" type="date" [(ngModel)]="editForm().resolvedAt" />
          </div>
        }
        <!--
        @if (editForm().substatus_id == 6 || editForm().substatus_id == 7) {
          <div class="">
            <h4>Completed</h4>
            <input class="fourd" type="date" [(ngModel)]="editForm().completedAt" />
          </div>
        }
        -->
      </div>
      <div class="mt-1">
        <h4>Description</h4>
        <textarea class="fourd" type="text" [(ngModel)]="editForm().description"></textarea>
      </div>
      <div>
        <div class="row-2">
          <div class="flex">
            <div>
              <div class="flex" title="Issue RAG">
                <div><app-chip label="Green" [noBackground]="true" [isRadio]="true" selectedBackgroundColour="#2ECC71" [checked]="editForm().rag === 'green'" (onChanged)="setRag('green')" /></div>
                <div><app-chip label="Amber" [noBackground]="true" [isRadio]="true" selectedBackgroundColour="#F28C38" [checked]="editForm().rag === 'amber'" (onChanged)="setRag('amber')" /></div>
                <div><app-chip label="Red" [noBackground]="true" [isRadio]="true" selectedBackgroundColour="#de0000" [checked]="editForm().rag === 'red'" (onChanged)="setRag('red')" /></div>
              </div>
            </div>
            <div class="flex-1"></div>
            <div class="">
              @if (issue().status === 'created' || issue().status === 'in progress' || issue().status === 'open') {
                <select class="fourd" title="Assignee" [(ngModel)]="editForm().assignee" name="assignee">
                  <option [ngValue]="null">Not assigned</option>
                  @for (user of orgUsers; track $index) {
                    <option value="{{ user.id }}">{{ user.name }}</option>
                  }
                </select>
              }
            </div>
            <div class="">
              @if (issue().status === 'in progress') {
                <select class="fourd" title="Status" [(ngModel)]="editForm().substatus_id" name="progress">
                  @for (option of statusOptions; track option.id) {
                    <option [value]="option.id">{{ option.title }}</option>
                  }
                </select>
              }
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <app-toolbar [hasBackground]="false">
        <div class="left">
          <app-button label="Delete" icon="mdi mdi-trash-can-outline" (click)="dialogConfirm.set('delete')" />
        </div>
        <div class="right">
          @if (isUpdating()) {
            <app-button icon="mdi mdi-check" [isDisabled]="true" label="Saving...." />
          } @else {
            <app-button label="Save" icon="mdi mdi-check" (click)="saveEdit()" [isCTA]="true" />
          }
        </div>
      </app-toolbar>
    </section>
  } @placeholder {
    <i class="mdi mdi-loading mdi-spin-x2"></i>
  }
</article>
@if (wantsToComplete()) {
  <app-dialog [dimensions]="{ width: 600, height: 410 }" (onClose)="wantsToComplete.set(false)" header="Complete Issue">
    <section class="content-container edit mt-1">
      <div class="flex">
        <div class="">
          <h4>Status</h4>
          <select class="fourd" title="Status" [(ngModel)]="completeEditForm().substatus_id" name="progress">
            @for (option of statusOptionsForComplete; track option.id) {
              <option [value]="option.id">{{ option.title }}</option>
            }
          </select>
        </div>
        <div class="ml-1">
          <h4>
            @if (completeEditForm().substatus_id == 6 || completeEditForm().substatus_id == 7) {
              Completed Date
            } @else {
              Cancelled Date
            }
          </h4>
          <input class="fourd" type="date" [(ngModel)]="completeEditForm().resolvedAt" />
        </div>
      </div>
      <div class="flex">
        <div class="mt-1 flex-1">
          <h4>
            @if (completeEditForm().substatus_id == 6 || completeEditForm().substatus_id == 7) {
              Completed Notes
            } @else {
              Cancelled Notes
            }
          </h4>
          <textarea class="fourd" type="text" [(ngModel)]="completeEditForm().completedNotes"></textarea>
        </div>
      </div>
    </section>
    <section class="text-right">
      <app-button [label]="completeEditForm().substatus_id == 6 || completeEditForm().substatus_id == 7 ? 'Complete' : 'Cancel'" icon="mdi mdi-check" (click)="completeIssue()" [isCTA]="true" />
    </section>
  </app-dialog>
}

@switch (dialogConfirm()) {
  @case ('delete') {
    <app-dialog [dimensions]="{ width: 490, height: issue().createdByName === user.name ? 160 : 180 }" (onClose)="dialogConfirm.set(null)" header="Delete this Issue?">
      <section class="content-container">
        <h3 class="mt-1 mb-1"><i class="mdi mdi-alert red"></i> You are about to delete this issue and it's history</h3>
        @if (issue().createdByName !== user.name) {
          <p class="text-center red"><b>This issue was not created by you.</b></p>
        }
        <app-toolbar [hasBackground]="false">
          <div class="right">
            <app-button label="Cancel" icon="mdi mdi-close" (click)="dialogConfirm.set(null)" class="mr-1" />

            <app-button label="DELETE" icon="mdi mdi-trash-can-outline" (click)="deleteClick('YES')" />
          </div>
        </app-toolbar>
      </section>
    </app-dialog>
  }
}
